import React, { useState } from 'react';

export const SourcesLink = ({ sources }) => {
  const [showSources, setShowSources] = useState(false);

  return (
    <div>
      <div
        onClick={() => setShowSources((prev) => !prev)}
        className="flex items-center gap-1 cursor-pointer source-link-button w-fit"
      >
        <span>{showSources ? 'Hide Sources' : 'Sources'}</span>
        {showSources ? (
          // Up Arrow SVG
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <g clipPath="url(#clip0_4089_470)">
              <path
                d="M8.2688 0.421178C7.90259 0.00265096 7.30786 0.00265098 6.94165 0.421178L2.25415 5.77832C1.88794 6.19685 1.88794 6.87653 2.25415 7.29506C2.62036 7.71359 3.21509 7.71359 3.5813 7.29506L6.66919 3.7627L6.66919 14.035C6.66919 14.6277 7.08813 15.1064 7.60669 15.1064C8.12524 15.1064 8.54419 14.6277 8.54419 14.035L8.54419 3.76604L11.6321 7.29171C11.9983 7.71024 12.593 7.71024 12.9592 7.29171C13.3254 6.87319 13.3254 6.1935 12.9592 5.77497L8.27173 0.417829L8.2688 0.421178Z"
                fill="#F1593F"
              />
            </g>
            <defs>
              <clipPath id="clip0_4089_470">
                <rect
                  width="15"
                  height="15"
                  fill="white"
                  transform="translate(0.106445 15.1064) rotate(-90)"
                />
              </clipPath>
            </defs>
          </svg>
        ) : (
          // Tick/Arrow SVG
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <g clipPath="url(#clip0_4093_296)">
              <path
                d="M16.1555 5.99382C16.1925 5.43893 15.7719 5.01839 15.217 5.05539L8.11441 5.5289C7.55952 5.56589 7.07891 6.0465 7.04191 6.60139C7.00492 7.15629 7.42546 7.57682 7.98035 7.53983L12.6616 7.22554L5.39795 14.4892C4.97889 14.9082 4.93657 15.543 5.30325 15.9097C5.66992 16.2764 6.30472 16.234 6.72377 15.815L13.985 8.55373L13.6755 13.2302C13.6385 13.7851 14.059 14.2057 14.6139 14.1687C15.1688 14.1317 15.6494 13.6511 15.6864 13.0962L16.1599 5.99353L16.1555 5.99382Z"
                fill="#F1593F"
              />
            </g>
            <defs>
              <clipPath id="clip0_4093_296">
                <rect
                  width="15"
                  height="15"
                  fill="white"
                  transform="translate(0 10.6064) rotate(-45)"
                />
              </clipPath>
            </defs>
          </svg>
        )}
      </div>

      {showSources && (
        <ul className="mt-2 list-disc list-outside pl-5 space-y-2">
          {sources.map((source, idx) => (
            <li key={idx} className="break-words">
              <a
                href={source}
                target="_blank"
                rel="noopener noreferrer"
                className="sources-link-text"
              >
                {source}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
